import { automaticThoughtIdType } from "api/conceptApi";
import {
  DateSelect,
  DimmedLabelLine,
  LineWithSolidLabel,
  SolidLabelLine,
  TextareaLine,
  TimeSelect,
  TypographyFromDataLine,
  TypographyLine,
} from "data/CellComponent";
import {
  Header1,
  Instruction,
  InstructionWithButtonGroup,
  InstructionWithContent,
  InstructionWithData,
  InstructionWithDataWithContent,
  InstructionWithDataWithTextarea,
  InstructionWithTextarea,
} from "../../BlockComponent";
import { Content_4_5_A_end, Content_4_5_A_start } from "./4-5-A";
import { AutomaticThought } from "../common";
import dayjs from "dayjs";

const now = dayjs();
const todayWithTime = now.format("HH:mm");

const today = dayjs().format("YYYY-MM-DD");
// Always set timeNormalized to a future time: next hour rounded to HH:00
const timeNormalized = dayjs().add(1, "hour").startOf("hour").format("HH:00");

export const Content_4_5_6_A = (automaticThoughtId: automaticThoughtIdType) => [
  ...Content_4_5_A_start(automaticThoughtId),
  Header1(`typography_0_0_0`),

  InstructionWithContent(
    `typography_1_0_0`,
    [`typography_1_3_0`, `typography_1_5_0`, `typography_1_7_0`].flatMap(
      (each, index) => [
        ...LineWithSolidLabel(`단계`, TypographyLine(each), {
          labelIndex: index + 1,
        }),
      ]
    )
  ),

  InstructionWithContent(
    `typography_2_0_0`,
    AutomaticThought({ id: automaticThoughtId })
  ),
  Instruction(`typography_3_0_0`),
  InstructionWithTextarea(`typography_4_0_0`),
  InstructionWithTextarea(`typography_5_0_0`),
  Instruction(`typography_6_0_0`),
  Instruction(`typography_7_0_0`),
  InstructionWithTextarea(`typography_8_0_0`),
  InstructionWithTextarea(`typography_9_0_0`),
  Instruction(`typography_10_0_0`),
  Instruction(`typography_11_0_0`),
  Instruction(`typography_12_0_0`),
  Instruction(`typography_13_0_0`),
  Instruction(`typography_14_0_0`),
  Instruction(`typography_15_0_0`),
  Instruction(`typography_16_0_0`),

  Instruction(`typography_16_0_1`),
  Instruction(`typography_16_0_2`),
  Instruction(`typography_16_0_3`),

  InstructionWithContent(`typography_16_0_4`, [
    [TimeSelect({ id: "time", value: todayWithTime, timeSelectStep: "minute" })],
  ]),

  InstructionWithData(
    { A: { id: "time" } },
    `typographyFromData_16_0_5`
  ),
  InstructionWithContent(
    `typography_16_0_5`,
    AutomaticThought({ id: automaticThoughtId })
  ),
  InstructionWithTextarea(`typography_16_0_6`, { optional: true }),
  InstructionWithTextarea(`typography_16_0_7`, { optional: true }),
  InstructionWithTextarea(`typography_16_0_8`, { optional: true }),
  InstructionWithTextarea(`typography_16_0_9`, { optional: true }),
  InstructionWithTextarea(`typography_16_0_10`, { optional: true }),

  InstructionWithButtonGroup(
    "typography_16_0_11",
    [
      {
        text: "충분했어요",
        showFromId: "enough",
        hideFromId: "not_enough",
      },
      {
        text: "부족했어요",
        showFromId: "not_enough",
        hideFromId: "enough",
      },
    ],
    {},
    { blockId: "select_enough_or_not_enough" }
  ),

  Instruction(`typography_16_0_12`, {
    blockId: "enough",
    nextBlockId: "finish",
  }),

  InstructionWithContent(
    `typography_16_0_13`,
    [
      ...LineWithSolidLabel("날짜", [DateSelect({ id: "date", value: today })]),
      ...LineWithSolidLabel("시각", [
        TimeSelect({ id: "time", value: timeNormalized }),
      ]),
    ],
    { blockId: "not_enough" }
  ),

  Instruction(`typography_16_0_14`, { nextBlockId: "finish" }),

  Instruction(`typography_16_0_15`, { blockId: "finish" }),
  Instruction(`typography_16_0_16`),

  InstructionWithDataWithTextarea(
    { A: { id: "생각" } },
    `typographyFromData_17_0_0`
  ),

  InstructionWithDataWithContent(
    { A: { id: "생각" } },
    `typographyFromData_18_0_0`,
    [
      ...[
        [`typography_18_4_0`, `typography_18_6_0`],
        [`typography_18_10_0`, `typography_18_12_0`],
      ].flatMap((each, index) => [
        SolidLabelLine(`예시`, { labelIndex: index + 1 }),
        DimmedLabelLine(`마음속에 떠오른 반추`),
        TypographyLine(each[0]),
        DimmedLabelLine(`거리두기를 통해 바라본 반추`),
        TypographyLine(each[1]),
      ]),
      SolidLabelLine(`나의 반추`),
      DimmedLabelLine(`마음속에 떠오른 반추`),
      TypographyFromDataLine({ A: { id: "생각" } }, "$A$"),
      DimmedLabelLine(`거리두기를 통해 바라본 반추`),
      TextareaLine(),
    ]
  ),

  Instruction(`typography_19_0_0`),

  // ...Content_4_5_A_end_type2(automaticThoughtId, 6),
  ...Content_4_5_A_end(automaticThoughtId, 6),
];
